import {Pipe, PipeTransform} from "@angular/core";
import {DecimalPipe} from "@angular/common";

@Pipe({name: "woaCurrency"})
export class CurrencyPipe implements PipeTransform {
    transform(value, symbol: string = "$", digits: string = "1.2-2") {
        return value == undefined ? undefined : (value < 0 ? "-" : "") + (symbol || "") + new DecimalPipe("en-US").transform(Math.abs(value), digits);
    }
}
